import { useContext } from "react";
import { DialogContext } from "./DialogContext";

export function useDialogContext() {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error(
      "useDialogContext must be used within a DialogContextProvider",
    );
  }
  return context;
}
